


















































    import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
    import Util from '@/lib/util'
    import AbpBase from '@/lib/abpbase'
    import PageRequest from '@/store/entities/page-request'
    import Enums from '@/lib/enums'
    import UpdateReturnOrder from './frontorderreturn-edit.vue'
    import CreateExpressReturn from '@/views/front/order/frontorderreturn-applyreturn.vue'
    import DateUtils from '@/common/js/DateUtils'
    import Preview from 'vue-photo-preview'
    import 'vue-photo-preview/dist/skin.css'
    import moment from 'moment'
    Vue.use(Preview);

    class PageUserExpressInfoRequest extends PageRequest {
        beginTime?: Date;
        endTime?: Date;
        orderNumber: string;
        whetherHandle: boolean;
        PlatformType: number;
        constructor() {
            super();
            this.PlatformType = null;
            
        }
    }

    @Component({
        name: "frontorderReturn",
        components: { UpdateReturnOrder, CreateExpressReturn }
    })
    export default class UserExpressInfo extends AbpBase {
        editModalShow: boolean = false;
        pagerequest: PageUserExpressInfoRequest = new PageUserExpressInfoRequest();
        whetherStatus = Enums.getEnum(Enums.WhetherStringStatus, true);
        PlatformType = Enums.getEnum(Enums.PlatformType, true);
        creationTime: Date[] = [moment(moment(new Date()).add(-15, 'days'), "YYYYMMDD").toDate(), new Date()];
        updateModalShow: boolean = false;
        createModalShow: boolean = false;
        get list() {
            return this.$store.state.frontorderreturn.list;
        };
        get loading() {
            return this.$store.state.frontorderreturn.loading;
        }

        pageChange(page: number) {
            this.$store.commit('frontorderreturn/setCurrentPage', page);
            this.getpage();
        }
        pagesizeChange(pagesize: number) {
            this.$store.commit('frontorderreturn/setPageSize', pagesize);
            this.getpage();
        }
        async operationData(name: any, data: any) {
            if (name == '申请退货') {
                this.$store.state.frontorderreturn.orderReturnInfo = data;
                this.createModalShow = true;
            }
            if (name == '编辑') {
                this.$store.state.frontorderreturn.orderReturnInfo = data;
                this.updateModalShow = true;
            }
            var _this: any = this;
            _this.$previewRefresh();
        }
        async searchPage() {
            this.$store.state.user.currentPage = 1;
            this.getpage();
        }
        async getpage() {
            this.pagerequest.maxResultCount = this.pageSize;
            this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
            //filters

            if (this.creationTime.length > 0) {
                this.pagerequest.beginTime = this.creationTime[0];
            }
            if (this.creationTime.length > 1) {
                this.pagerequest.endTime = this.creationTime[1];
            }

            await this.$store.dispatch({
                type: 'frontorderreturn/getAll',
                data: this.pagerequest
            })
        }

        get pageSize() {
            return this.$store.state.frontorderreturn.pageSize;
        }
        get totalCount() {
            return this.$store.state.frontorderreturn.totalCount;
        }
        get currentPage() {
            return this.$store.state.frontorderreturn.currentPage;
        }
        columns = [{
            title: '快递单号',
            key: 'shipment',
            width: 200,

        }, {
            title: '订单编号',
            key: 'orderNumber',
            width: 200,
            fixed: 'left',
            },
            {
                title: '订单类型',
                width: 90,
                key: 'orderType',
                render: (h: any, params: any) => {
                    return h('span', Enums.WarehouseOrderType.filter(function (item) { return item.value == params.row.orderType })[0].name);
                }
            },{
            title: '仓库名称',
            key: 'warehouseName',
            width: 200,
        }, {
            title: '用户编码',
            key: 'userCode',
            width: 200,
        }, {
            title: '是否标为已处理',
            key: 'whetherHandle',
            width: 120,
            render: (h: any, params: any) => {
                return h('span', params.row.whetherHandle ? this.L('是') : this.L('否'))
            }
        }, {
            title: '创建时间',
            key: 'createTime',
            width: 150,
            render: (h: any, params: any) => {
                return h('span', DateUtils.formatLongDate(new Date(params.row.createTime)));
            }
        }, {
            title: '退回时间',
            key: 'returnTime',
            width: 150,
            render: (h: any, params: any) => {
                return h('span', DateUtils.formatLongDate(new Date(params.row.returnTime)));
            }
        }, {
            title: '备注',
            width: 220,
            key: 'reMark',
        }, {
            title: '操作',
            width: 100,
            fixed: 'right',
            key: 'id',
            render: (h: any, params: any) => {
                var _this = this;
                var menu = [];
                menu.push("编辑");
                menu.push("申请退货");
                return h('Dropdown', {
                    props: {
                        transfer: true,
                        trigger: 'click',
                    },
                    on: {
                        'on-click': (name) => {
                            _this.operationData(name, params.row);
                        }
                    }

                }, [
                    h('Button',
                        {
                            domProps: {
                                innerHTML: '<span>操作<i class="ivu-icon ivu-icon-ios-arrow-down"></i></span>',
                            },
                            props: {
                                type: 'primary',
                            }

                        }),
                    h('DropdownMenu', { slot: 'list' }, menu.map(item => {
                        return h('DropdownItem', { props: { name: item } }, item)
                    })
                    )]);
            }
        }]
        async created() {

            this.getpage();
        }
    }
